import { render, staticRenderFns } from "./UsualPowerComparisonMessage.vue?vue&type=template&id=b2dc48f8&"
import script from "./UsualPowerComparisonMessage.vue?vue&type=script&lang=ts&"
export * from "./UsualPowerComparisonMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports